import { MemberType } from "./MemberType";

/**
 * 依頼者情報
 * TODO: Customer系統との継承関係の整理
 */
export interface BusinessRequesterInfo {
    /**
     * 
     */
    type: "Business"
    /**
     * 依頼企業名
     */
    companyName: string,
    /**
     * 部署名
     */
    departmentName?: string,
    /**
     * メンバータイプがguestの場合空文字
     */
    id: string,

    /**
     * 名
     */
    firstname: string,

    /**
     * 姓
     */
    lastname: string,

    /**
     * 県
     */
    prefecture?: string,
    /**
     * 市住所
     */
    city?: string,

    /**
     * 市以降の住所
     */
    address?: string,

    /**
     * 郵便番号
     */
    zipcode?: string,
    /**
     * 電話番号
     */
    tel?: string,
    /**
     * メールアドレス
     */
    mailaddress?: string
}

/**
 * BusinessRequesterInfoかどうかを判定します。
 * @param arg 判定対象
 * @returns BusinessRequesterInfoであればtrue
 */
export function isBusinessRequesterInfo(arg: any): arg is BusinessRequesterInfo {
    return arg?.type === MemberType.Business;
}



export function createDefaultRequester(): BusinessRequesterInfo {
    return {
        id: "",
        companyName: "",
        firstname: "",
        lastname: "",
        mailaddress: "",
        type: MemberType.Business,
        tel: "",
    };
}